module.exports = "/wwwroot/img/heart-light.svg?ver=d19dcead";